import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from "@angular/core";
import {FormBarge} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-visit-exemptions-vessel-barge',
    templateUrl: './exemptions_vessel_barge.component.html',
    styleUrls: ['./exemptions_vessel_barge.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExemptionsVesselBargeComponent {

  @Input() formBarge : FormBarge;
  @Input() vesselPrefix: string;

  @Output() removeBarge = new EventEmitter<void>();

  notifyParent() {
    this.removeBarge.emit(); // Emit event to parent
  }
}
